class MinerwaShowcase extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-marquee-track]');
    if (!this.track) return;

    this.track.dataset.paused = 'true';

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.track.dataset.paused = entry.isIntersecting ? 'false' : 'true';
      },
      { threshold: 0 },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('minerwa-showcase')) {
  customElements.define('minerwa-showcase', MinerwaShowcase);
}
